module.exports = __webpack_public_path__ + "static/media/default.03a5178a.png";


//////////////////
// WEBPACK FOOTER
// ./src/preserveValue/index/default.png
// module id = 1200
// module chunks = 0